import { fetchItemsApp } from 'clients/learnosity'
import { rerenderMathJax } from 'clients/mathjax'
import pager from './printer/pager'
import watchQuestionLoading from './printer/watch_question_loading'
import { logAndNotify } from 'utils/log_and_notify'
import { vueInitialized } from './application'

export async function onReadyPrint(ngieConfig) {
  await vueInitialized
  if (ngieConfig) {
    const questionLoadingPromise = watchQuestionLoading()
    try {
      await fetchItemsApp(ngieConfig)
    } catch (e) {
      logAndNotify(e)
    }
    await questionLoadingPromise
  }

  const mathEls = document.querySelectorAll('.math-tex')
  mathEls.forEach((mathEl) => {
    rerenderMathJax(mathEl)
  })

  window.MathJax.Hub.Queue(async () => {
    await pager()
    document.querySelector('.loading').remove()
    document.querySelector('#un-formatted').remove()
    document.querySelectorAll('.page-content').forEach((e) => e.classList.add('overflow-hidden'))
    window.setTimeout(window.print, 400)
  })
}
